import { render, staticRenderFns } from "./DetailDriverScore-v2.vue?vue&type=template&id=5d25167c&scoped=true&"
import script from "./DetailDriverScore-v2.vue?vue&type=script&lang=js&"
export * from "./DetailDriverScore-v2.vue?vue&type=script&lang=js&"
import style0 from "./DetailDriverScore-v2.vue?vue&type=style&index=0&id=5d25167c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d25167c",
  null
  
)

export default component.exports